

import React, { useState, useEffect } from "react";
import { getAllUser } from "../actions/users";
import AdminOverview from "../admin/AdminOverviwe"; // Import AdminOverview component
// import CompanyDetailsForm from "./CompanyDetailsForm"; // Import CompanyDetailsForm component
import ContactButton from "../ContactButton";
import { Link } from "react-router-dom";
import Buttons from "./Buttons_Dash";

const Dashboard = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    async function fetchUserData() {
      try {
        const res = await getAllUser();
        if (res.success) {
          const authStr = localStorage.getItem("auth");
          const authObj = JSON.parse(authStr);
          const isAdmin = authObj?.data?.userData?.isAdmin;
          setIsAdmin(isAdmin);
        } else {
          console.error("Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching user data", error);
      }
    }
    fetchUserData();
  }, []);

  return (
    <div>
      {isAdmin ? (
        <AdminOverview />
      ) : (
        // <CompanyDetailsForm companyNameProp="Your Company Name" />
        <div>
          {/* <h1>company Dashboard</h1> */}
        </div>
      )}

      <div>
        <h1 className="text-[#C0C0C0] text-2xl p-2 m-2 orbitron">
          Bulid your own Dasboard with Ironglass Byte
        </h1>
        <ContactButton />
      </div>
    </div>
  );
};

export default Dashboard;
